import { useHTranslate, fallbackLocaleKey } from '@/composables/use-translate';
import { useHUpdateTranslations } from '@/composables/use-update-translations';
import { Pinia } from 'pinia';
import { App } from 'vue';

/**
 * A Vue plugin that provides translation functionalities.
 *
 * @function
 * @name oCreateTranslatePlugin
 * @description
 * This function creates a Vue plugin for handling translations within a Vue application.
 * It sets up a global translation function and provides a fallback locale.
 *
 * @param {Pinia} pinia - The Pinia instance used for state management.
 * @param {string} [localeFallback='en'] - The fallback locale to use if no translation is found.
 * @returns {Object} An object containing the `install` method to install the plugin.
 */
export function oCreateTranslatePlugin(pinia: Pinia, localeFallback = 'en') {
  return {
    install(app: App) {
      app.config.globalProperties.$t = useHTranslate;

      app.provide(fallbackLocaleKey, localeFallback);

      app.runWithContext(() => {
        useHUpdateTranslations(pinia);
      });
    },
  };
}
